import { ReactElement } from "react";

interface IProps {
  children: ReactElement;
}
const AuthLayout = ({ children }: IProps) => {
  return (
    <div className="min-h-screen w-full bg-background flex flex-col justify-center items-center">
      {children}
    </div>
  )
}

export default AuthLayout;
